<template>

    <!-- ============================================================== -->
                <!-- Start Page Content -->
                <!-- ============================================================== -->
                <!-- Row -->
  
                <!-- Row -->
  <v-flex xs12 sm6 offset-sm3 class="distancebtom">
  <v-card  class="card-outline-inverse " >
      <v-card-text dark class="card-header">
        <h5 class="m-b-0 text-white" style="text-align: left;">
            Campaign Request
        </h5>
      </v-card-text>
     
        <v-tabs
            v-model="active_tab">
          <v-tab  class="grey--text fixWidth " active-class="nav-link active">
              Approval ({{numberOfApprovalCount}}) 
          </v-tab>
         
          <v-tab-item :key="'tab_details'" class="box-1 px-12" v-show="showTabA"> 
            <v-card flat class="txleft">
              <ul  v-if=" numberOfApprovalCount > 0 "  class="search-listing">
                <li v-for="(item1, index1) in campaignApproval">
                   <p> 
                       {{item1.request_user_name}}
                        
                      <span class="sl-date font-blue">{{item1.created_on}}</span>
                    </p> 
                    <span class="cusfont16px" v-on:click.capture='goToDetail(item1.campaign_id,"approval" )'>({{item1.campaign_id}})
                     <a> {{item1.campaign_name}}</a>
                    </span> 
                </li>
              </ul>
              <v-card-text class="notfound" v-else>No Data Found</v-card-text>
            </v-card>
          </v-tab-item>
           <v-tab  class="grey--text fixWidth " :key="'tab_related_songs'"  active-class="nav-link active">
              AIO ({{numberOfAioCount}}) 
          </v-tab>
          <v-tab-item :key="'tab_related_songs'" class="box-1 px-12" v-show="showTabAI">
            <v-card flat class="txleft"> 
             <ul v-if="numberOfAioCount  > 0 "  class="search-listing">
                <li v-for="(item, index) in campaignAios">
                    <p> 
                         {{item.request_user_name}}
                      <span class="sl-date font-blue">{{item.created_on}}</span>
                    </p> 
                    <span class="cusfont16px" v-on:click.capture='goToDetail(item.campaign_id,"aio" )'>({{item.campaign_id}})
                       <a > {{item.campaign_name}}</a>
                   
                    </span>
                </li>
              </ul>
              <v-card-text class="notfound" v-else>No Data Found</v-card-text>
            </v-card>
          </v-tab-item>

        </v-tabs> 

      
   </v-card>
 </v-flex>
</template>
<script>
  import { loginService } from '@/components/_service/Users.js'
  export default {
    name: 'CampaignRequest',
    data () {
      return {
        
        loading:true,
        showTabA: false,
        showTabAI: false,
        active_tab : 0,
        camcount:0,
        
      }
    },
    created() {
      this.getCampaignAIO()
      this.getCampaignApproval() 
      
    },
    beforeUpdate() {
      // console.log(this.active_tab)
        this.camcount =  (this.$store.state.numberOfAioCount + this.$store.state.numberOfApprovalCount);

        this.$emit('cam-send', this.camcount);

    //  if (!this.$route.query.act || (this.$route.query.act !="flight_costing" || this.$route.query.act !="pending_flight" || this.$route.query.act !="delete_flight") || this.$route.query.act !="aio"  ){
         // console.log(this.$route.query.act)
          // console.log(this.$store.state.numberOfApprovalCount)
          // console.log(this.$store.state.numberOfAioCount)
          // console.log("focus"); 
          if ( (this.$store.state.numberOfApprovalCount ==  0 && this.$store.state.numberOfAioCount == 0) || (this.$store.state.numberOfApprovalCount >  0 && this.$store.state.numberOfAioCount > 0) || (this.$store.state.numberOfApprovalCount >  0 && this.$store.state.numberOfAioCount== 0)) {
               this.showTabA = true
               this.active_tab = 0
               
          }
        //  console.log(this.$store.state.numberOfAioCount)
          if (this.$store.state.numberOfApprovalCount ==  0 && this.$store.state.numberOfAioCount > 0 ){
              this.showTabAI = true;
              this.active_tab = 1
          } 

    //  } 
    },
     mounted () {
     //  console.log( this.camcount )

         if (this.$route.query.act==="approval"){
           this.active_tab = 0
           this.showTabA = true
            
         }
      //  console.log(this.$route.query.act)
         if (this.$route.query.act==="aio"){
             this.showTabAI = true;
             this.active_tab = 1
           //    console.log("aio")
        }
        if ( (this.$store.state.numberOfApprovalCount ==  0 && this.$store.state.numberOfAioCount == 0) || (this.$store.state.numberOfApprovalCount >  0 && this.$store.state.numberOfAioCount > 0) || (this.$store.state.numberOfApprovalCount >  0 && this.$store.state.numberOfAioCount== 0)) {
               this.showTabA = true
               this.active_tab = 0
               
          }
        //  console.log(this.$store.state.numberOfAioCount)
          if (this.$store.state.numberOfApprovalCount ==  0 && this.$store.state.numberOfAioCount > 0 ){
              this.showTabAI = true;
              this.active_tab = 1
          } 
       
        // if (!this.$route.query.act || (this.$route.query.act !="flight_costing" || this.$route.query.act !="pending_flight" || this.$route.query.act !="delete_flight")  && this.$route.query.act !="aio"  ){
        //  // console.log(this.$route.query.act)
        //   if ( (this.$store.state.numberOfApprovalCount ==  0 && this.$store.state.numberOfAioCount == 0) || (this.$store.state.numberOfApprovalCount >  0 && this.$store.state.numberOfAioCount > 0) || (this.$store.state.numberOfApprovalCount >  0 && this.$store.state.numberOfAioCount== 0)) {
        //        this.showTabA = true
        //        this.active_tab = 0
        //       // console.log("focus");
        //   }
        //  // console.log(this.$store.state.numberOfAioCount)
        //   if (this.$store.state.numberOfApprovalCount ==  0 && this.$store.state.numberOfAioCount > 0 ){
        //       this.showTabAI = true;
        //       this.active_tab = 1
        //   }    
        // } 
        

    },
    computed:{
      isTabA(){
            if ( this.$route.query.act && this.$route.query.act==="approval"){
          
              return true
            } 

      },
      isTabAI(){
          if (this.$route.query.act && this.$route.query.act==="aio"){
             return true
             
           }
      },
      numberOfAioCount(){
         return this.$store.state.numberOfAioCount;
      },
      numberOfApprovalCount(){
         return this.$store.state.numberOfApprovalCount;
      },
      campaignApproval(){
       // console.log(this.$store.state.campaignApproval)
        return this.$store.state.campaignApproval;
      },
      campaignAios(){
        return this.$store.state.campaignAios;
      },
    },
    methods:{
       getCampaignAIO () {
           this.$store.dispatch('getCampaignRequest','campaign_aio')
             .then(() => 

                this.loading =false
              )
             .catch(err => {
                console.log(err )
               
             })
             .finally(() => this.loading = false)
        },
        getCampaignApproval () {
            this.$store.dispatch('getCampaignRequest','campaign_approval')
             .then(() => 

                this.loading =false
             
              )
             .catch(err => {
                console.log(err )
               
             })
             .finally(() => this.loading = false)
        },
        goToDetail(camid,act){
          this.$router.push({ name: 'detail', params: { id: camid,flightid:0 }, query:{act:act} })
         // this.$router.push({ name: 'detail', params: { id: camid  }, query:{act:act} })
        
        },
    }, 
   
  }
</script>